export default "__VITE_ASSET__CJRgWwBI__"